import * as THREE from "three";
import { useMemo, useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import {
  Trail,
  Float,
  Line,
  Sphere,
  Stars,
  OrbitControls,
  Environment,
  useGLTF,
  Sky as SkyImpl,
  Clouds,
  Cloud,
} from "@react-three/drei";
import { EffectComposer, Bloom } from "@react-three/postprocessing";
import { Planet } from "../models/KaiPlanet";
import { useControls } from "leva";

// import { Cloud } from "../models/Cloud";

export default function Trails() {
  function Sky() {
    const ref = useRef();
    const cloud0 = useRef();
    // const { color, x, y, z, range, ...config } = useControls({
    //   seed: { value: 1, min: 1, max: 100, step: 1 },
    //   segments: { value: 20, min: 1, max: 80, step: 1 },
    //   volume: { value: 6, min: 0, max: 100, step: 0.1 },
    //   opacity: { value: 0.8, min: 0, max: 1, step: 0.01 },
    //   fade: { value: 10, min: 0, max: 400, step: 1 },
    //   growth: { value: 4, min: 0, max: 20, step: 1 },
    //   speed: { value: 0.0, min: 0, max: 1, step: 0.01 },
    //   x: { value: 6, min: 0, max: 100, step: 1 },
    //   y: { value: 1, min: 0, max: 100, step: 1 },
    //   z: { value: 1, min: 0, max: 100, step: 1 },
    //   color: "#f2ff6e",
    // });
    // useFrame((state, delta) => {
    //   ref.current.rotation.y = Math.cos(state.clock.elapsedTime / 2) / 2;
    //   ref.current.rotation.x = Math.sin(state.clock.elapsedTime / 2) / 2;
    //   cloud0.current.rotation.y -= delta;
    // });
    return (
      <>
        {/* <SkyImpl /> */}
        <group ref={ref}>
          <Clouds
            material={THREE.MeshStandardMaterial}
            limit={100}
            // range={range}
          >
            <Cloud
              ref={cloud0}
              concentrate="outside"
              growth={100}
              color="#FFFF00"
              opacity={1}
              seed={1}
              bounds={200}
              volume={200}
            />
            {/* <Cloud
              
              bounds={[6,1,1]}
              color="#FFFF00"
              seed={2}
              position={[15, -10, 0]}
            />
            <Cloud
              
              bounds={[6,1,1]}
              color="#FFFF00"
              seed={3}
              position={[-15, -10, 0]}
            />
            <Cloud
             
              bounds={[6,1,1]}
              color="#FFFF00"
              seed={4}
              position={[0, -10, -12]}
            />
            <Cloud
          
              bounds={[6,1,1]}
              color="#FFFF00"
              seed={5}
              position={[0, -10, 12]}
            /> */}
            {/* <Cloud
              concentrate="outside"
              growth={100}
              color="#FFFF00"
              opacity={1.25}
              seed={10.3}
              bounds={200}
              volume={200}
            /> */}
          </Clouds>
        </group>
      </>
    );
  }
  return (
    <div className="w-screen h-screen">
      <Canvas
        camera={{ position: [-1.2, 35.9, -40.9], rotation: [-2.2, -0.2, -2.7] }}
      >
        <color attach="background" args={["hotPink"]} />
        <Float speed={4} rotationIntensity={1} floatIntensity={2}>
          <Atom />
        </Float>
        {/* <Stars saturation={0} count={400} speed={0.5} /> */}
        {/* <Sky distance={-10000} /> */}
        <Sky />
        <Environment preset="dawn" />
        <Planet />
        <EffectComposer>
          <Bloom intensity={0.5} mipmapBlur luminanceThreshold={1} radius={0.7} />
        </EffectComposer>
        <OrbitControls />
      </Canvas>
    </div>
  );
}

function Atom(props) {
  const points = useMemo(
    () =>
      new THREE.EllipseCurve(0, 0, 3, 1.15, 0, 2 * Math.PI, false, 0).getPoints(
        100
      ),
    []
  );
  return (
    <group {...props}>
      {/* <Electron position={[0, 0, 0.5]} speed={6} /> */}
      {/* <Electron position={[0, 0, 0.5]} rotation={[0, 0, Math.PI / 3]} speed={5} /> */}
      <Electron
        position={[0, 0, 0.5]}
        rotation={[0, 0, -Math.PI / 6]}
        speed={5}
      />
      {/* <Sphere args={[0.55, 64, 64]}>
        <meshBasicMaterial color={[6, 0.5, 2]} toneMapped={false} />
      </Sphere> */}
    </group>
  );
}

function Electron({ radius = 60, speed = 0.6, ...props }) {
  const { nodes, materials } = useGLTF("/cloud.glb");
  const ref = useRef();
  useFrame((state) => {
    const t = state.clock.getElapsedTime() * speed;
    ref.current.position.set(
      Math.sin(t) * radius * 0.5,
      (Math.cos(t) * radius * 1.2 * Math.atan(t)) / Math.PI / 1.5,
      Math.sin(t) * radius * 0.5
    );
    // console.log("Position:", state.camera.position.x, state.camera.position.y, state.camera.position.z)
    // console.log("Rotation:", state.camera.rotation.x, state.camera.rotation.y, state.camera.rotation.z)
  });
  return (
    <group {...props}>
      <Trail
        local
        width={10}
        length={10}
        color={new THREE.Color(2, 1, 10)}
        attenuation={(t) => t * 6 * t}
      >
        <mesh ref={ref}>
          <sphereGeometry args={[0.25]} />
          <meshBasicMaterial color={[10, 1, 10]} toneMapped={false} />
          {/* <group ref={ref} {...props} dispose={null}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_2.geometry}
              material={materials.material_0}
              rotation={[Math.PI / 2, 0, 0]}
              scale={[0.01, 0.01, 0.01]}
            />
          </group> */}
        </mesh>
      </Trail>
    </group>
  );
}
